import React from "react";
import {withNamespaces} from "react-i18next";
import {Button} from "react-bootstrap";

const WidgetExhibitionScenario = ({exhibitionScenarioList, t, scenarioList = {}, callbackAction}) => {

    const handleActions = (action) => {
        callbackAction(action);
    };

    const groups = scenarioList.deviceGroups?.map((group) => {
        return (
            <div className="list-group-item list-group-item-action" key={group.groupId}>
                <div className="row">
                    <div className="col-md-3 d-flex">
                        <span className="text-wrap font-weight-bold align-self-center" >{group.groupLabel}</span>
                    </div>
                    <div className="col-md-7">
                        <div className="flex-wrap">
                            { exhibitionScenarioList?.map((item, idx) => {
                                return (
                                    <Button
                                        className="m-1"
                                        active={item.id === group.scenarioId}
                                        key={idx}
                                        variant={"outline-primary"}
                                        onClick={() => handleActions(`ChangeExhibitionScenario/${item.id}/${group.groupId}`)}>
                                        { item.label }
                                    </Button>
                                )
                            }) }
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="float-right">
                            <Button
                                className="m-1"
                                variant={"outline-info"}
                                onClick={() => handleActions(`ChangeExhibitionScenario/0/${group.groupId}`)}
                            >
                                <i className="fas fa-sync"/>&nbsp;{ t('reset') }
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        )
    });

    return (
        <div className="mt-2">
            <div className="card">
                <div className="card-header">
                    <b><span className="card-title"> { t('exhibition-scenario') } </span></b>
                </div>
                <div className="card-body">
                    <div className="list-group mx-2">
                        <div className="list-group-item list-group-item-action">
                            <div className="row">
                                <div className="col-md-3 d-flex">
                                    <span className="text-wrap font-weight-bold align-self-center" >{t('all-groups-change')}</span>
                                </div>
                                <div className="col-md-7">
                                    <div className="flex-wrap">
                                        { exhibitionScenarioList?.map((item, idx) => {
                                            return (
                                                <Button
                                                    className="m-1"
                                                    key={idx}
                                                    variant={"outline-secondary"}
                                                    onClick={() => handleActions(`ChangeExhibitionScenario/${item.id}`)}
                                                >
                                                    { item.label }
                                                </Button>
                                            )
                                        }) }
                                    </div>
                                </div>

                                <div className="col-md-2">
                                    <div className="float-right">
                                        <Button
                                            className="m-1"
                                            variant={"outline-info"}
                                            onClick={() => handleActions(`ChangeExhibitionScenario/0`)}
                                        >
                                            <i className="fas fa-sync"/>&nbsp;{ t('reset') }
                                        </Button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="divider"/>
                <div className="card-body">
                    <div className="list-group mx-2">
                        { groups }
                    </div>
                </div>
            </div>
        </div>
    )
};
export default withNamespaces()(WidgetExhibitionScenario);
